import { Component, OnInit, Inject } from '@angular/core';
import { ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { AuthService } from '../../../services/auth.service';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import { Voucher } from 'src/app/models/voucher';
import { VoucherService } from 'src/app/services/voucher.service';
import { MemberService } from 'src/app/services/member.service';
import { EmailService } from 'src/app/services/email.service';
import { Sponsor } from 'src/app/models/sponsor';
import { Product } from 'src/app/models/product';


/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

export interface User {
  name: string;
}

@Component({
  selector: 'app-voucher-dialog',
  templateUrl: './voucher-dialog.component.html',
  styleUrls: ['./voucher-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class VoucherDialogComponent implements OnInit {

  public local_title: string;
  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean = false; // is insert or update
  public spinner: boolean = false;

  public members: any[] = []
  public searchMemberControl: FormControl;

  public current_sponsor: Sponsor;
  public current_voucher: Voucher;
  public current_product: Product;


  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private _voucherService: VoucherService,
    private _memberService: MemberService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    private _emailService: EmailService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.current_voucher = this.data.voucher;
    this.current_product = this.data.product;
    this.current_sponsor = this.data.sponsor;
  }

  ngOnInit() {

    this._adapter.setLocale('pt');

    if (this.current_voucher.member_name) {
      this.isEdit = true;
    }

    this.entityForm = this.createForm()
    this.setFormValues(this.current_voucher, this.entityForm)

    this.initializeAutoCompletes()

  }


  update() {

    if (this.entityForm.valid) {
      let entity = this.createEntity(this.entityForm.value);

      console.log("entity: " + JSON.stringify(entity))
      console.log("---------------------------------------------")

      this._voucherService.update(entity)
        .then(() => {

          let send_email: any = {
            'html': this.createEmail(entity),
            'subject': "SBCCV Voucher",
            "from": "SBCCV <cientifico@sbccv.org.br>",
            'to': entity.member_email,
            'bcc': "cientifico@sbccv.org.br"
          }

          this._emailService.sendStandardEmail(send_email)
            .then(() => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success');
            })
            .catch((error) => {
              console.log("ERROR")
            })


        })
        .catch((error) => {
          console.log("voucher update error: " + JSON.stringify(error))
          let msgError: string = this._voucherService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });

    }

  }


  createEmail(entity: Voucher) {

    let email: any = "";

    email += "<div style='width: 600px; background-color: white; margin: auto; padding: 20px;'>"

    email += "  <div style='display: flex; flex-direction: row; justify-content: space-between;'>"
    email += "    <div style='margin-top:20px; font-size: 16px;'>"
    email += "      <div>" + entity.member_name + "</div>"
    email += "      <div>Você ganhou um voucher!</div>"
    email += "      <div>Ao se inscrever no</div>"
    email += "      <div>" + this.current_product.name + ", </div>"
    email += "      <div>informe este codigo:</div>"
    email += "      <div style='color:darkorange;'><b>" + entity.name + "</b></div>"
    email += "      <div>e ganhe um desconto de R$ " + entity.discount + ".</div>"
    email += "    </div>"
    email += "    <div style='width: 200px;'>"
    email += "      <img style='width: 200px;' src='https://firebasestorage.googleapis.com/v0/b/sbccv-proj.appspot.com/o/images%2Flogos%2Fsbccv_logo.png?alt=media&token=8c5cbbab-9e24-43b8-bc89-869735fe32b3'>"
    email += "    </div>"
    email += "  </div>"

    email += "  <div styyle='width: 100%;'>"
    email += "    <div style='width: 100%; margin: 80px 0 20px 0; text-align: center; font-size: 20px;'>"
    email += "      <a href='" + this.current_sponsor.url + "'>"
    email += this.current_sponsor.name
    email += "      </a>"
    email += "    </div>"
    email += "    <div style='width: 300px; margin: auto;'>"
    email += "      <img style='width: 250px;' src='" + this.current_sponsor.image + "'>"
    email += "    </div>"
    email += "  </div>"

    email += "  <div styyle='width: 100%;'>"
    email += "    <div style='width: 100%; margin: 80px 0 20px 0; text-align: center; font-size: 20px;'>"
    email += this.current_product.name
    email += "    </div>"
    email += "    <div style='width: 300px; margin: auto;'>"
    email += "      <img style='width: 250px; margin: auto;' src='" + this.current_product.image + "'>"
    email += "    </div>"
    email += "  </div>"

    email += "</div>"

    return email

  }

  createEntity(data: any): Voucher {

    let entity = new Voucher();
    entity.id = data.id;
    entity.name = data.name;

    entity.discount = data.discount;
    entity.used = data.used;
    entity.date_sent = data.date_sent ? data.date_sent : new Date();

    entity.product_id = data.product_id;
    entity.product_name = data.product_name;

    entity.sponsor_id = data.sponsor_id;
    entity.sponsor_name = data.sponsor_name;

    entity.member_id = data.member_id;
    entity.member_name = data.member_name;
    entity.member_email = data.member_email;

    return entity;
  }

  setFormValues(data, form) {

    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);

    form.controls.member_id.setValue(data.member_id);
    form.controls.member_name.setValue(data.member_name);
    form.controls.member_email.setValue(data.member_email);

    form.controls.product_id.setValue(data.product_id);
    form.controls.product_name.setValue(data.product_name);

    form.controls.sponsor_id.setValue(data.sponsor_id);
    form.controls.sponsor_name.setValue(data.sponsor_name);

    form.controls.used.setValue(data.used);
    form.controls.discount.setValue(data.discount);
    form.controls.date_sent.setValue(data.date_sent);

  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),

      discount: new FormControl(''),
      used: new FormControl(''),
      date_sent: new FormControl(''),

      member_id: new FormControl('', [Validators.required]),
      member_name: new FormControl('', [Validators.required]),
      member_email: new FormControl('', [Validators.required]),

      product_id: new FormControl('', [Validators.required]),
      product_name: new FormControl('', [Validators.required]),

      sponsor_id: new FormControl('', [Validators.required]),
      sponsor_name: new FormControl('', [Validators.required]),

    });
    return form
  }


  // AUTOCOMPLETES

  initializeAutoCompletes() {

    this.searchMemberControl = new FormControl();
    this.searchMemberControl.valueChanges.subscribe(val => {
      if (val != undefined) this.updateMemberSearchList(val);
    })

  }

  // MEMBERS AUTOCOMPLETE

  cleanMemberSearch() {
    this.members = []
  }

  updateMemberSearchList(val) {

    if (val.length > 3) {

      this._memberService.selectStartAt(val)
        .subscribe((result) => {

          this.members = []

          result.forEach((item) => {
            if(item.data().deleted) return
            this.members.push({
              'id': item.id,
              'name': item.data().name,
              'email': item.data().email
            })

          })

        })

    }
  }

  displayMember(value) {

    if ((value !== null) && (value !== undefined) && (value !== "")) {

      this.entityForm.controls.member_id.setValue(value.id);
      this.entityForm.controls.member_name.setValue(value.name);
      this.entityForm.controls.member_email.setValue(value.email);

      return value.name;

    } else {
      return "";
    }

  }

  // FIM AUTOCOMPLETE
}
